import { Link } from "react-router-dom";
import { Trophy } from "lucide-react";

const STYLE = {
  1: { h: "h-44 md:h-56", ring: "border-[#962FFF]/60 shadow-[0_0_40px_rgba(150,47,255,0.25)]", num: "text-[#d6b3ff]", label: "Campione" },
  2: { h: "h-32 md:h-40", ring: "border-[#C6C6CE]/40", num: "text-[#F5F5F7]", label: "Secondo posto" },
  3: { h: "h-24 md:h-32", ring: "border-[#C6C6CE]/20", num: "text-[#C6C6CE]", label: "Terzo posto" },
};

function Step({ row }) {
  const s = STYLE[row.position];
  return (
    <div data-testid={`podium-place-${row.position}`} className="flex-1 flex flex-col items-center min-w-0">
      {row.position === 1 && <Trophy className="w-7 h-7 text-[#962FFF] mb-2" strokeWidth={1.5} />}
      <div className="text-center mb-3 px-1 min-w-0 w-full">
        {row.tag && <div className="font-num text-[10px] text-[#C6C6CE]/60">[{row.tag}]</div>}
        {row.clan_slug ? (
          <Link to={`/clan/${row.clan_slug}`} className="block font-display font-bold uppercase text-sm md:text-lg text-[#F5F5F7] truncate hover:text-[#962FFF] transition-colors duration-200">{row.name}</Link>
        ) : <div className="font-display font-bold uppercase text-sm md:text-lg text-[#F5F5F7] truncate">{row.name}</div>}
        <div className="font-num text-xs text-[#C6C6CE]/70">{row.points} pt</div>
        {row.prize && <div className="text-[10px] text-[#d6b3ff] mt-1 truncate">{row.prize}</div>}
      </div>
      <div className={`w-full ${s.h} rounded-t-md border border-b-0 bg-gradient-to-b from-[#17171D] to-[#0B0B0F] ${s.ring} flex flex-col items-center justify-start pt-4`}>
        <div className={`font-num font-bold text-4xl md:text-5xl ${s.num}`}>{row.position}</div>
        <div className="text-[9px] uppercase tracking-[0.2em] text-[#C6C6CE]/50 mt-1 hidden sm:block">{s.label}</div>
      </div>
    </div>
  );
}

export function Podium({ rows }) {
  const top = (rows || []).slice(0, 3);
  if (!top.length) return null;
  const order = [top[1], top[0], top[2]].filter(Boolean);
  return (
    <div data-testid="podium" className="flex items-end gap-2 md:gap-4 max-w-3xl mx-auto">
      {order.map((r) => <Step key={r.registration_id} row={r} />)}
    </div>
  );
}
